import CheckInProfile from './CheckInProfile';

export default CheckInProfile;
